/* KCSE practicals landing page — tracking events, WhatsApp routing, form → WhatsApp, form click id.
   Pairs with sections/kcse-*.liquid.

   Tracking: pushes to GTM's dataLayer. GTM turns these into the GA4 event
   and the Google Ads conversion — nothing here talks to Google directly.
     kcse_whatsapp_click  { kcse_location: hero|sticky|card|stock_foot|form, kcse_product }
     kcse_quote_submit    pushed by kcse-quote.liquid when Shopify confirms the post
     kcse_call_click      { kcse_location: hero|sticky }
   The ref code + gclid logging on WhatsApp clicks is still done by
   snippets/ss-attribution.liquid (theme.liquid, every page) — not duplicated here. */
(function () {
  'use strict';

  window.dataLayer = window.dataLayer || [];

  /* ---------- WhatsApp routing by shop hours ----------
     Same rule as the product pages: shop phone (data-day) while the shop is
     open, Amina the bot (data-night) otherwise. sst-bar.js normally does this,
     but the contact bar — and so sst-bar.js — is off on this page.
     KEEP HOURS IN SYNC with sst-bar.js. Nairobi = UTC+3, no daylight saving.
     ?wa=night / ?wa=day force either, for testing. */
  var HOURS = { 1: [8, 17], 2: [8, 17], 3: [8, 17], 4: [8, 17], 5: [8, 17], 6: [8, 13] };

  function shopOpen() {
    if (/[?&]wa=night/.test(location.search)) return false;
    if (/[?&]wa=day/.test(location.search)) return true;
    var d = new Date(Date.now() + 3 * 60 * 60 * 1000);
    var h = HOURS[d.getUTCDay()];
    var hour = d.getUTCHours() + d.getUTCMinutes() / 60;
    return !!h && hour >= h[0] && hour < h[1];
  }

  var waLinks = document.querySelectorAll('[data-sst-wa-route]');
  function route() {
    var open = shopOpen();
    waLinks.forEach(function (a) {
      a.setAttribute('href', open ? a.dataset.day : a.dataset.night);
    });
  }
  route();
  setInterval(route, 60 * 1000);
  // On the link itself, so it runs BEFORE ss-attribution's document-level
  // listener adds the (Ref SS-…) code — running after would wipe the ref.
  waLinks.forEach(function (a) { a.addEventListener('click', route); });

  /* ---------- WhatsApp message from the quote form ----------
     data-kcse-fill="live"  : rewritten as the visitor types
     data-kcse-fill="saved" : on the success message after a send — the page
                              reloads on submit, so the details are kept in
                              sessionStorage (this tab only) and read back. */
  var SAVED = 'kcse_quote_form';
  var MAX_LIST = 1500; // keeps the wa.me URL well inside phone/browser limits

  function buildText(d) {
    var lines = ["Hi, I'd like a quote for our KCSE practicals."];
    lines.push('School: ' + (d.school || '___'));
    lines.push('County: ' + (d.county || '___'));
    if (d.name || d.phone) lines.push('Contact: ' + [d.name, d.phone].filter(Boolean).join(', '));
    if (d.list) {
      var list = d.list.length > MAX_LIST ? d.list.slice(0, MAX_LIST) + '… (full list sent via the website form)' : d.list;
      lines.push('', 'Our list:', list);
    }
    return lines.join('\n');
  }

  function setWaText(a, text) {
    var enc = encodeURIComponent(text);
    ['day', 'night'].forEach(function (k) {
      if (a.dataset[k]) a.dataset[k] = a.dataset[k].replace(/([?&]text=)[^&#]*/, '$1' + enc);
    });
    route();
  }

  var form = document.getElementById('kcse-quote-form');
  function readForm() {
    function v(id) { var el = document.getElementById(id); return el ? el.value.trim() : ''; }
    return { school: v('kcse-school'), county: v('kcse-county'), name: v('kcse-name'),
             phone: v('kcse-phone'), list: v('kcse-list') };
  }

  if (form) {
    var live = form.querySelectorAll('[data-kcse-fill="live"]');
    var onInput = function () {
      var d = readForm();
      if (!d.school && !d.county && !d.name && !d.phone && !d.list) return; // keep the default message
      var text = buildText(d);
      live.forEach(function (a) { setWaText(a, text); });
    };
    form.addEventListener('input', onInput);
    onInput(); // browser may restore typed values on back/refresh
    form.addEventListener('submit', function () {
      try { sessionStorage.setItem(SAVED, JSON.stringify(readForm())); } catch (err) {}
    });
  }

  try {
    var saved = JSON.parse(sessionStorage.getItem(SAVED) || 'null');
    if (saved) {
      document.querySelectorAll('[data-kcse-fill="saved"]').forEach(function (a) { setWaText(a, buildText(saved)); });
    }
  } catch (err) {}

  // Call taps (ss-attribution logs the call itself for the bot backend)
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-kcse-call]');
    if (!a) return;
    try {
      window.dataLayer.push({ event: 'kcse_call_click', kcse_location: a.getAttribute('data-kcse-call') });
    } catch (err) {}
  }, false);

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-kcse-wa]');
    if (!a) return;
    try {
      window.dataLayer.push({
        event: 'kcse_whatsapp_click',
        kcse_location: a.getAttribute('data-kcse-wa') || 'other',
        kcse_product: a.getAttribute('data-kcse-product') || ''
      });
    } catch (err) {}
  }, false);

  // Quote form: carry the ad click id into the email, so a form lead can be
  // matched to its Google Ads click the same way WhatsApp refs are.
  try {
    var field = document.querySelector('[data-kcse-click]');
    if (field) {
      var c = JSON.parse(localStorage.getItem('ss_ad_click') || 'null');
      if (c && c.id) field.value = c.type + ':' + c.id;
    }
  } catch (err) {}

})();
